<template>
<div :class="['row', { 'has-main-action': mainAction }]">
	<div @click="mainAction_ClickHandler" class="group-l">
		<div class="block block-small">
			<avatar class="sk-avatar-margin" :size="35" :src="src" :name="value" />
		</div>
		<div class="block block-grow">
			<span class="value">{{ value }}</span>
			<span class="title">{{ title }}</span>
		</div>
	</div>
	<div class="block">
		<slot></slot>
	</div>
	<div :class="['block__loading', { 'block__loading--active': loading }]"><spinner v-if="loading"/></div>
</div>
</template>

<script>
import Avatar from '@/modules/ui/Avatar'
export default {
	name: 'grid-item-warning',
	components: {
		Avatar
	},
	props: {
		src: {
			type: String
		},
		title: {
			type: String
		},
		value: {
			type: String|Number
		},
		loading: {
			type: Boolean,
			default: false
		},
		mainAction: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		mainAction_ClickHandler() {
			if (!this.mainAction) {
				return
			}
			this.$emit('click', {})
		}
	}
}
</script>

<style scoped>
.row {
	border-radius: 3px;
	background-color: #fff;
	box-shadow: rgba(0,0,0,0.3) 0 0 5px;
	margin: 10px 0;
	display: flex;
	position: relative;
}
.group-l {
	display: flex;
	flex: 1;
}
.has-main-action .group-l {
	cursor: pointer;
	transform-origin: left center;
	background-color: rgba(0,0,0,0);
	transform: translate(0, 0) scale(1, 1);
	transition: all 0.3s;
}
.has-main-action .group-l:hover,
.has-main-action .group-l:active {
	background-color: rgba(0,0,0,0.01);
	transform: translate(5px, 0) scale(1, 1);
}
.block {
	padding: 10px 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.block-small {
	padding: 0 0 0 20px;
	align-items: center;
	justify-content: center;
}
.block-grow {
	flex: 1;
}
.title {
	color: #aaa;
	font-size: 12px;
	min-height: 14px;
}
.b-picture {
	width: 35px;
	height: 35px;
	background-color: var(--main-color);
	border-radius: 100%;
	box-shadow: rgba(0,0,0,0.1) 0 0 5px;
}
.value {
	min-height: 20px;
}
.value.v-center {
	text-align: center;
}
.block__loading {
	background-color: rgba(255, 255, 255, 0.5);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: 3px;
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 0.3s, opacity 0.3s 0s;
	display: flex;
	align-items: center;
	justify-content: center;
}
.block__loading.block__loading--active {
	visibility: visible;
	opacity: 1;
	transition: visibility 0s 0s, opacity 0.3s 0s;
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/GridItemWarning.vue